// extracted by mini-css-extract-plugin
module.exports = {"columnHeader":"TableConfigColumnHeader_columnHeader__L__f4"};